import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileSingle, DesktopSingle } from './displays'
import { baseStyles } from './styles'

type YouTubeShortProps = {
  accountImage: AssetReference | null
  accountName: string
  assets: AssetReference[]
  collabEnabled?: boolean
  collabAccount?: string
  content: string
  display: 'mobileSingle' | 'desktopSingle'
  isPresenting: boolean
  isSnapshot: boolean
  onExpandAsset: (id: number) => void
  onRemoveAsset: (id: number) => void
  paidPromotion: boolean
  readOnly: boolean
  sound: string
  updateText: (val: string, destination: string) => void
}

export const YouTubeShort: React.FC<YouTubeShortProps> = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  content,
  display,
  isPresenting = false,
  isSnapshot = false,
  onExpandAsset,
  onRemoveAsset,
  paidPromotion,
  readOnly = false,
  sound,
  updateText,
}) => {
  const displays = {
    mobileSingle: MobileSingle,
    desktopSingle: DesktopSingle,
    default: MobileSingle,
  }
  const RenderDisplay = displays[display] || displays.default
  const video = assets[0] || null

  return (
    <div
      css={baseStyles({ display, hasAsset: Boolean(video) })}
      className={kuiperClassNames(
        'youtube youtube-short',
        `youtube-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        readOnly={readOnly}
        onContentChange={(val: string) => updateText(val, 'content')}
        onSoundChange={(val: string) => updateText(val, 'sound')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        paidPromotion={paidPromotion}
        username={accountName}
        video={video}
        content={content}
        sound={sound}
      />
    </div>
  )
}
